import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Componente que intercepta as ações de autenticação do Firebase
 * e redireciona para as páginas corretas da aplicação
 */
const AuthActionHandler: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');

    if (!mode) {
      // Se não tem mode, redireciona para home
      navigate('/');
      return;
    }

    switch (mode) {
      case 'resetPassword':
        // Redireciona para a página de redefinir senha com o código
        if (oobCode) {
          navigate(`/redefinir-senha?oobCode=${oobCode}`);
        } else {
          navigate('/esqueci-senha');
        }
        break;

      case 'verifyEmail':
        // Poderia adicionar verificação de email aqui no futuro
        navigate('/login');
        break;

      case 'recoverEmail':
        // Recuperação de email
        navigate('/login');
        break;

      default:
        navigate('/');
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#2B5A41] to-[#203C2E] flex items-center justify-center">
      <div className="text-white text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p>Redirecionando...</p>
      </div>
    </div>
  );
};

export default AuthActionHandler;
